<template>
  <div class="gallery-icon">
    <svg class="arrow arrow1" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2" d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z" transform="translate(0 0)" fill="#DADADA"/>
    </svg>
    <svg class="arrow arrow2" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2" d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z" transform="translate(0 0)" fill="#DADADA"/>
    </svg>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.gallery-icon  {
  border: 2px solid #DADADA;
  width: 36px;
  height: 36px;
  cursor: pointer;
  position: relative;
}
.gallery-icon:hover .arrow1{
  transform: rotate(
    227deg
  ) scale(1.2);
}
.gallery-icon:hover .arrow2{
  transform: rotate(
    45deg
  ) scale(1.2);
}
.gallery-icon .arrow {
  position: absolute;
  width: 10px;
  height: 10px;
  transition: .3s ease;
}
.gallery-icon .arrow1 {
  top: 5px;
  left: 5px;
  transform: rotate(
    227deg
  );
}
.gallery-icon .arrow2 {
  bottom: 5px;
  right: 5px;
  transform: rotate(
    45deg
  );
}
</style>
